import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { CcResponse } from "server/models"
import { StoreType, addModal, LangType } from "client/store"
import {
    Link,
    TableColumn,
} from "client/components"

import Edit from "../edit"

const langId = "en" // display translation only for English, hide others

const Columns = (
    editAccess: boolean,
    module: number,
) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
        },
        {
            field: `response_${langId}`,
            header: lang[langId as keyof LangType],
            cellMinWidth: "100px",
            formatter: (response: CcResponse) => {
                const translations = response.translations ? JSON.parse(response.translations) : {}
                const text = translations[langId]

                if (!editAccess) return text
                return (
                    <Link
                        href="/#"
                        onClick={() => dispatch(addModal({
                            key: "editResponse",
                            content: <Edit responseId={response.id} module={module} />,
                        }))}
                    >
                        {text}
                    </Link>
                )
            },
        },
    ]

    if (module !== 0) { // if not "responsible"
        columns.push({
            field: "approved",
            header: lang.approved,
            cellMinWidth: "100px",
            formatter: (response: CcResponse) => (response.approved ? lang[response.approved] : null),
        })
    }

    if (editAccess) {
        columns.unshift({
            field: "sort",
            centerAlign: true,
        })
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
